import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { nanoid } from "nanoid";

const CaltexCheckbox = (props) => {
    return (
        <FormGroup sx={{ padding: "0 .5rem", display: "flex", flexDirection: "column", gap: ".5rem" }}>
            {props.options && props.options.length > 0
                ? props.options.map((option) => {
                      return (
                          <FormControlLabel
                              key={nanoid()}
                              label={option}
                              control={
                                  <Checkbox
                                      color="info"
                                      name={option}
                                      onChange={props.onChange}
                                      checked={props.value.includes(option)}
                                      sx={{ marginRight: ".5rem", width: "27px", height: "27px" }}
                                  />
                              }
                          />
                      );
                  })
                : null}
        </FormGroup>
    );
};

export default CaltexCheckbox;
